module.exports = __webpack_public_path__ + "assets/img/7.40de7798.png";